import {
  addFlashMessage as addFlashMessageAction,
  deleteFlashMessage as deleteFlashMessageAction
} from '../actions/flashMessage'

export function addFlashMessage(message) {
  return dispatch => {
    dispatch(addFlashMessageAction({
      type: 'success',
      text: message,
    }));
  }
}

export function deleteFlashMessage(id) {
  return dispatch => {
    dispatch(deleteFlashMessageAction({
      id: id
    }));
  }
}
